<div class="step-panel step-panel-documentos">
  <h3>Documentos</h3>
  <p class="step-intro">Adjunta los documentos que exige la base del concurso y mantenlos actualizados dentro del borrador.</p>

  <div class="info-banner">
    Cada documento valida formato y tamano maximo antes de quedar asociado a la postulacion. Si existe un CV registrado en Curriculum, este paso puede reutilizarlo como documento precargado y aun asi permitir reemplazo o eliminacion.
  </div>

  <div class="doc-list">
    <div class="doc-item doc-item-column" *ngFor="let config of documentosRequeridos">
      <div class="doc-main">
        <div class="doc-row-head">
          <div class="doc-meta">
            <strong>{{ config.titulo }} <span *ngIf="config.obligatorio">*</span></strong>
            <span>{{ config.descripcion }}</span>
            <span class="doc-rules">
              Formatos: {{ config.extensionesPermitidas.join(', ').toUpperCase() }} |
              Maximo: {{ config.tamanoMaximoMb }} MB<span *ngIf="config.tamanoMaximoZipMb"> (ZIP hasta {{ config.tamanoMaximoZipMb }} MB)</span>
            </span>
            <span class="doc-rules" *ngIf="config.sugerenciaPaginas">{{ config.sugerenciaPaginas }}</span>
          </div>
        </div>

        <div class="doc-file-box" *ngIf="obtenerDocumento(config.tipo) as documento; else pendienteTpl">
          <div class="doc-file-meta">
            <strong>{{ documento.nombreArchivo }}</strong>
            <span>{{ formatearTamano(documento.tamanoBytes) }} | .{{ documento.extension }} | Cargado correctamente</span>
            <span class="doc-rules" *ngIf="documento.origen === 'curriculum'">Precargado desde Curriculum</span>
          </div>
        </div>

        <ng-template #pendienteTpl>
          <div class="doc-placeholder">
            <span>Aun no se ha adjuntado archivo para este requerimiento.</span>
          </div>
        </ng-template>
      </div>

      <div class="doc-side">
        <span
          class="status-pill"
          [class.status-ok]="obtenerDocumento(config.tipo)"
          [class.status-pending]="!obtenerDocumento(config.tipo)"
        >
          {{ obtenerDocumento(config.tipo) ? 'Cargado' : 'Pendiente' }}
        </span>

        <ng-container *ngIf="obtenerDocumento(config.tipo); else pendienteActionTpl">
          <div class="doc-actions">
            <label class="btn-secondary doc-action-button" *ngIf="!soloLectura">
              Reemplazar
              <input
                type="file"
                class="hidden-file-input"
                [accept]="acceptPara(config)"
                (change)="seleccionarDocumento($event, config)"
              />
            </label>

            <button type="button" class="btn-secondary doc-action-button doc-action-danger" *ngIf="!soloLectura" (click)="eliminarDocumento(config.tipo)">
              Eliminar
            </button>
          </div>
        </ng-container>

        <ng-template #pendienteActionTpl>
          <label class="btn-primary doc-upload-button" *ngIf="!soloLectura">
            Cargar archivo
            <input
              type="file"
              class="hidden-file-input"
              [accept]="acceptPara(config)"
              (change)="seleccionarDocumento($event, config)"
            />
          </label>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="placeholder-box" *ngIf="mensajeDocumento">
    <strong>Estado de carga:</strong> {{ mensajeDocumento }}
  </div>

  <div class="placeholder-box">
    <strong>Tipos permitidos:</strong> PDF, DOCX, XLSX, ZIP, JPG, JPEG y PNG. El borrador conserva los metadatos del archivo para que el usuario pueda reemplazarlo o eliminarlo antes del envio.
  </div>
</div>
